export const apiCreate = (): string => '/commercial/providers/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/providers/' : `/commercial/providers/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/providers/update/${id}`
export const apiDelete = (id: string): string => `/commercial/providers/${id}`
